import { InjectionToken } from '@angular/core';

export const SHARED_ENVIRONMENT = new InjectionToken('SHARED_ENVIRONMENT');
